import { useCallback } from 'react';
import { useAccountStore } from '../../../entities/account';
import { accountsApi } from '../../../shared/api/accounts.api';
import type { Account } from '../../../entities/account';

/**
 * Feature: Загрузка аккаунтов
 * Хук для загрузки списка аккаунтов с сервера
 */
export function useLoadAccounts() {
  const setAccounts = useAccountStore((state) => state.setAccounts);
  const setLoading = useAccountStore((state) => state.setLoading);
  const setError = useAccountStore((state) => state.setError);

  const loadAccounts = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await accountsApi.getAll();
      const { accounts } = response;
      
      setAccounts(
        accounts.map((acc: Account) => ({
          ...acc,
          tags: acc.tags || [],
          igId: acc.igId || '',
          followersCount: acc.followersCount || 0,
          followsCount: acc.followsCount || 0,
          mediaCount: acc.mediaCount || 0,
          biography: acc.biography || '',
          website: acc.website || '',
          createdAt: acc.createdAt instanceof Date ? acc.createdAt : new Date(acc.createdAt),
          updatedAt: acc.updatedAt instanceof Date ? acc.updatedAt : new Date(acc.updatedAt),
          accessTokenExpiry: acc.accessTokenExpiry instanceof Date ? acc.accessTokenExpiry : new Date(acc.accessTokenExpiry),
        }))
      );
      
      setLoading(false);
    } catch (error) {
      console.error('Error loading accounts:', error);
      setError(error instanceof Error ? error.message : 'Failed to load accounts');
      setLoading(false);
    }
  }, [setAccounts, setLoading, setError]);

  return { loadAccounts };
}